import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_protected/_settingsLayout/settings/community_ai",
)({
  beforeLoad: () => {
    redirect({ to: "/settings/general", throw: true });
  },
});
